import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { CreatingGameComponent } from './creating-game/creating-game.component';
import { GameComponent } from './game/game.component';
import { SettingsComponent } from './settings/settings.component';
import { CanActivateRemoteGameGuard } from './game/can-activate-remote-game.guard';
import { CanActivateRemoteGameSettingsGuard } from './settings/can-activate-remote-game-settings.guard';

const routes: Routes = [
  { path: 'remote/settings', component: SettingsComponent, canActivate: [CanActivateRemoteGameSettingsGuard]},
  { path: 'remote/creating-game', component: CreatingGameComponent},
  { path: 'remote/game', component: GameComponent, canActivate: [CanActivateRemoteGameGuard]}
];

export const ModuleRouting: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/remote/remote.routing.ts